import React from 'react';

import Separator from '@bit/kards.kards-components.separator';

export default ({ data }) => <Separator.component data={data} />;
